import { render, staticRenderFns } from "./prescriptionEditor.vue?vue&type=template&id=259d37c2&scoped=true&"
import script from "./prescriptionEditor.vue?vue&type=script&lang=js&"
export * from "./prescriptionEditor.vue?vue&type=script&lang=js&"
import style0 from "./prescriptionEditor.vue?vue&type=style&index=0&id=259d37c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259d37c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('259d37c2')) {
      api.createRecord('259d37c2', component.options)
    } else {
      api.reload('259d37c2', component.options)
    }
    module.hot.accept("./prescriptionEditor.vue?vue&type=template&id=259d37c2&scoped=true&", function () {
      api.rerender('259d37c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/library/components/prescriptionEditor.vue"
export default component.exports